import React, { useMemo } from 'react';
import styled from 'styled-components';
import { DOT_COLORS } from '@/../shared-constants/map-constants';

export const PropertyDotSpan = styled.div`
  height: 17px;
  width: 17px;
  background-color: ${(props) => props.color};
  border-radius: 50%;
  border: 2px solid white;
  display: inline-block;
  opacity: 0.85;
`;

function isNullString(value) {
  return value === 'null';
}

export function PropertyDot({ property }) {
  const color = useMemo(() => {
    /**
     * "displayPopupAndDoManyOtherThings" method of rendering this component
     * results in fields with values of "null" being converted to the string "null"
     */
    if (!property.shortTermRental || isNullString(property.shortTermRental))
      return DOT_COLORS.fallback;
    /**
     * "displayPopupAndDoManyOtherThings" method of rendering this component
     * results in fields with values of "null" being converted to the string "null"
     */
    if (property.apn && !isNullString(property.apn))
      return property.strLicense
        ? DOT_COLORS.isLicensed
        : DOT_COLORS.unLicensed;
    if (property.live) return DOT_COLORS.isLiveWithoutAPN;
    return DOT_COLORS.fallback;
  }, [
    property.apn,
    property.live,
    property.shortTermRental,
    property.strLicense,
  ]);

  return <PropertyDotSpan color={color} />;
}
